import React, { useState } from "react";
import "./AdminDashboard.css";
import ProductsManager from "./ProductManager"; // Ensure file name matches your project
import CategoriesManager from "./CategoriesManager";
import CouponsManager from "./CouponsManager";
import OrdersManager from "./OrderManager"; // <-- 1. Imported the new component

function AdminDashboard() {
  // You can change "products" to "orders" here if you want Orders to be the default screen
  const [activeTab, setActiveTab] = useState("products");

  return (
    <div className="admin-page">
      <div className="admin-shell">
        <div className="admin-header">
          <div>
            <span className="admin-badge">Store Admin</span>
            <h1>Store Management</h1>
            <p>
              Manage orders, products, categories, coupons, SKU details, and image
              galleries from one place.
            </p>
          </div>
        </div>

        <div className="admin-tabs">
          {/* 2. Added the Orders Tab */}
          <button
            className={activeTab === "orders" ? "admin-tab active" : "admin-tab"}
            onClick={() => setActiveTab("orders")}
          >
            Orders
          </button>

          <button
            className={activeTab === "products" ? "admin-tab active" : "admin-tab"}
            onClick={() => setActiveTab("products")}
          >
            Products
          </button>

          <button
            className={activeTab === "categories" ? "admin-tab active" : "admin-tab"}
            onClick={() => setActiveTab("categories")}
          >
            Categories
          </button>

          <button
            className={activeTab === "coupons" ? "admin-tab active" : "admin-tab"}
            onClick={() => setActiveTab("coupons")}
          >
            Coupons
          </button>
        </div>

        <div className="admin-content">
          {/* 3. Render the OrdersManager when the tab is active */}
          {activeTab === "orders" && <OrdersManager />}
          {activeTab === "products" && <ProductsManager />}
          {activeTab === "categories" && <CategoriesManager />}
          {activeTab === "coupons" && <CouponsManager />}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;